module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/pages/management/curricula/add-edit-curriculum/add-edit-curriculum.component.scss
// module id = ./src/app/main/content/pages/management/curricula/add-edit-curriculum/add-edit-curriculum.component.scss
// module chunks = main